import React, { useEffect } from 'react';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import BookingsManager from './BookingsManager';
import InvoicesManager from './InvoicesManager';
import PropertiesManager from './PropertiesManager';

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login');
    } else if (user.role === 'property_responsible') {
      // Redirect property responsibles to their portal
      navigate('/responsabile/dashboard');
    }
  }, [user, navigate]);

  if (!user || user.role === 'property_responsible') {
    return null;
  }

  // Route users to their appropriate dashboard based on role
  switch (user.role) {
    case 'admin':
      return <AdminDashboard />;
    case 'bookings_operator':
      return <BookingsManager />;
    case 'customer_service':
      return <PropertiesManager />;
    case 'invoice_operator':
      return <InvoicesManager />;
    default:
      return <AdminDashboard />;
  }
};

export default Dashboard;